var _line, _line2, _line3, _line4, _path, _path2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackDutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 7.82114,
    x2: 13.7038,
    y2: 7.82114,
    stroke: "black",
    strokeWidth: 0.88897
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.2586,
    y1: 12,
    x2: 13.2586,
    y2: 8.2621,
    stroke: "black",
    strokeWidth: 0.88897
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.801609,
    y1: 12,
    x2: 0.801609,
    y2: 3.27823,
    stroke: "black",
    strokeWidth: 0.88897
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 10.3133,
    x2: 13.7038,
    y2: 10.3133,
    stroke: "black",
    strokeWidth: 0.88897
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73828 4.96777C4.18065 4.96793 4.53906 5.32693 4.53906 5.76953C4.53899 6.21208 4.18061 6.57113 3.73828 6.57129C3.29582 6.57129 2.93659 6.21217 2.93652 5.76953C2.93652 5.32683 3.29578 4.96777 3.73828 4.96777Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.88897
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68652 4.96777H11.2139C12.1913 4.96783 13.007 5.654 13.21 6.57031H6.68652C6.24431 6.57012 5.88574 6.21081 5.88574 5.76855C5.88597 5.32649 6.24446 4.96796 6.68652 4.96777Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.88897
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.24219,
    width: 3.87612,
    height: 3.87663,
    fill: "url(#pattern0_9548_20724)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_9548_20724",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9548_20724",
    transform: "scale(0.010418 0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9548_20724",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFWElEQVR4nO2d3YtVVRTAf5PNONaMTalQM+pLEr1JCelUBIGM5Uf10GM9RKHQpOZ/0GOUffgxENVTbxVJPoogVJAZ0UwzEag52qT1oE5FPjSBs2PDuiDB8d5zzl77rHPu/sF6Ge7su/ba5+6PtdZeBxKJRCKRSCQSiUTCFquAMWA3MAEcB6aBc8A8sCAyL3+bls8clv8ZkzYSHbIM2AG8A/wALAKupPg2pqTN7UB/1Z20yAbgAHAlgMHbyZ/AR8BmoIcuZimwC/g5gtGz5CywU3TpqmlmH3CpQsP/Xy4Ce0W3RuPn4FkDBncZ4hfyrTSQtcDnBgzsOpQjwGoawlPAVQNGdQUW62epMbcCrwfaSrqKZFF2Z33UjDuBrwwY0AWSL4AhasI9cvBxDZMf67AurAPOGzCWU5Lz0keTDDfc+E5kDliDMe5o6LTjMmRG1jkT9DVswXU5FuZeDPCuAWO4iuTNqo3/TOR9/hxwCHgCuB+4HbhNTtrbgDci+5gWxX1eCWslEBLLWfYSsKTDA+DzwG+RdPOn/BEqIJZv5ygwWEC/5cBnkXT8lAq8mjE6dhC4pYSePeJKiKHrFiKxLJJL+WhJ47fwbXwSKbgTJdy5L9KcPxhQ56FIi7NPBFBlqRhHuyMvttHBd/Qb4JrEkb8EXmizL38u0i5N1XO6K1InlmR8/0ibE/d3wMqM/+2VtrX197s1FXoiBdAP3eTJ78TdMXmTIPuHEfQ/o5Vt8VgE5R3wZMb378nRxqsZbbwfqQ+PagxAjKfHAfdlfP+pHG38LueAG7lL/h6jD36gg289/4qk/GCGDn/nbMcP2Ki4Kx4Gvo2kv5c/Qm9Jd0RUPgtXMwma3uLzKtMAkEv2hxwAnyibBoBc8n0o46+K7HLOwtVMrgMrCMCYsqL/iNNtoyyY2vjv2CTnjQXlvvkM7NLsVlTwIrCe6nhA2Uc0HkLJw4pP/nqq50HFX4L/ZZfmuJJyB7CD1kN2LIRyM0rKPYQdNin10e8eS3NBSbkB7DCg1EcfuCqNVmq5NTT6eDmEYloLlDW0NhqNG4B+uc91SiJi1yQ6tqfkZTuzA6B1dbQIq9u4RaZKpJCbnYK0Mp6LPPmd+KSmCv4SzC7CWtvQvOxVzk4wuw3VOojlJU9E7GTu1g0fxLROiXnJExHzn82L2dO+ljNOcwB8+DQvGn18GcPu6G6YgoK4o1cqBWTykict5ZXcrRsOyKB0/ysveRKziqQHmg1Jet42MADIIWuqjfGLXpYwHZTXuA9QlFZy7klZmL18LdNOmcTYWBl+heiXZCMLA6BFyL7NaxSB+iANAJ3Ke3VIzh3ADssD9+0RDSV75BpOKCU3YofRgP06rVkMcGeEewBVMBHpdk9p/MLyayBFFyQvx0LJzH8D9emXGMWd8riF28mligdhQ+AL3UESsTq5KxDyqtKCeFxHIy3MA3JfYCLgk9+a+6PVH90SUHHXEAl68OqEIwY67YzIx1TAmpqWo3QKgXdfLawSttW8LKUrKb7vT1MxbxkwhKtIfF3UyumV8l2uy+SElZJlLV/KpAGjuEgybbGQ67DxyugukMxKcVqTrGv4IMwC92Kcuxs6Hc1UVRuuCEMNW5hPSHHaWuGrF74m6Rmu5uXre6kx2yO9HckFlity0GwEI1La0dXItzNMA3kc+MmAgV2GnJWqvI2mX/J65gwY/MZI1ni3vU+sTwrcnanQ8Kclhlu7d8RovcrwcgSjp1cZtpmetoqHdTLQFva6JMrul6hVV00zZVkhT+q4pLEck+TccxIMar3O9qr8bUo+c1AuR2wOmSKeSCQSiUQikUgkEgTgP8yFbpdjWQf9AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDutIcon);
export default __webpack_public_path__ + "static/media/black-dut-icon.c668e714e66bb3a55e0c2c21d9d8bd56.svg";
export { ForwardRef as ReactComponent };